
import { Component, Vue } from 'vue-property-decorator';
import { getLoanInfo } from '@/api/loan';
import { LoanDetailsData } from '@/interfaces/loan';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import CurrencyFormatLong from '@/filters/CurrencyFormatLong';
import ProductInfoDialog from './LoanDetailsProductInfoDialog.vue';
import PurchaseWindowInfoDialog from './LoanDetailsPurchaseWIndowInfoDialog.vue';

@Component({
  components: {
    ProductInfoDialog,
    PurchaseWindowInfoDialog,
    CustomButton,
  },
  filters: {
    CurrencyFormatLong,
  },
})
export default class LoanDetails extends Vue {
  loanDetails: LoanDetailsData | null = null;

  loadingPage = false;

  showPurchaseWindowInfoDialog = false;

  showProductInfoDialog = false;

  async mounted() {
    this.loadingPage = true;
    const loanNumber = this.activeLoanNumber;
    try {
      const { data } = await getLoanInfo(loanNumber);
      this.loanDetails = data;
    } finally {
      this.loadingPage = false;
    }
  }

  get activeLoanNumber(): string {
    return this.$store.getters['User/activeLoanNumber'];
  }
}
